﻿import {
    Container,
    Dropdown,
    Navbar,
    Nav,
    NavDropdown,
    NavItem
} from "react-bootstrap";

import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { useAppContext } from "./AppContext";
import { ChimeApi } from "./ChimeApi";
import "./App.css";

interface UserAvatarProps {
    userPhotoUrl: string | undefined
};

function UserAvatar(props: UserAvatarProps) {
    const apiRoot:string = (document.getElementById("ApiRoot")as HTMLInputElement)?.value ?? "";
    // If a user avatar is available, return an img tag with the pic
    return <img src={ props.userPhotoUrl ?? apiRoot+"ChimeV5.Webclient/images/defaultPhoto.jpg"} alt="user"
        className="rounded-circle align-self-center mr-2"
        style={{ width: "32px" }}></img>;
}

function ShowBrandingImage() {    
    const show = ((document.getElementById("settings.showBrandingImage") as HTMLInputElement)?.value === "True") ? true : false;
    return show;
}

function BrandingImagePath() {    
    let brandingImagePath = "";
    try {
        brandingImagePath = (document.getElementById("settings.brandingImagePath") as HTMLInputElement)?.value;
    }
    catch {
        brandingImagePath = "_branding/tenant-logo.png";
    }
    return <img src={("./media/" + brandingImagePath).replace(/\s/g, '')}
        height="55px"
        className="d-inline-block align-top Navbar-img-padding"
        alt="Brand Logo image" />    
}

function SetNavbarTitle() {
    // NOTE: titleSetting does not always have a .length property, use try/catch to avoid the whole app from breaking
    try {
        const titleSetting = (document.getElementById("settings.navbarTitle") as HTMLInputElement)?.value;
        let title = (titleSetting.length > 0) ? titleSetting : ChimeApi.SiteName();
        return title;
    } catch(error) {
        console.log("NavbarTitle error", error);
        return ChimeApi.SiteName();
    }
}

export default function NavBar() {
    const app = useAppContext();
    const user = app.user || { displayName: "", mail: "" };
    const autoStart = new URLSearchParams(window.location.search).get("autoStart")?.toLowerCase() === "true";
    const reloadChat = () => {
        window.location.reload();
    };

    return (
        <Navbar bg="white" expand="lg" className="px-0 border-bottom Navbar-max-height">
            <Container fluid>
                <div className="d-flex align-items-center">
                    {ShowBrandingImage() ? <BrandingImagePath /> : null}
                    <h2 className="mb-0">{ SetNavbarTitle() }</h2>                 
                </div>
                <Nav className="ms-auto d-flex justify-content-end .navbar-expand-lg" navbar>
                    {autoStart ? (
                        <NavItem>
                            <Nav.Link href={window.location.href} onClick={(event) => {
                                event.preventDefault();
                                reloadChat();
                            }}>New Chat</Nav.Link>
                        </NavItem>
                    ) : (
                        <>
                            <AuthenticatedTemplate>
                                <NavDropdown title={<UserAvatar userPhotoUrl={app.photoUrl} />} id="user-dropdown" align="end">
                                    <h5 className="dropdown-item-text mb-0">{user.displayName}</h5>
                                    <p className="dropdown-item-text text-muted mb-0">{user.mail}</p>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={app.signOut!}>Sign Out</Dropdown.Item> 
                                </NavDropdown>
                            </AuthenticatedTemplate>
                            <UnauthenticatedTemplate>
                                <NavItem>
                                    <Nav.Link onClick={app.signIn!}>Sign In</Nav.Link>
                                </NavItem>
                            </UnauthenticatedTemplate>
                        </>
                    )}
                </Nav> 
            </Container>
        </Navbar>
    );
}